var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiColorGamepad = function SvgMultiColorGamepad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4056F7",
    d: "m15.979 6.823 3.003.822V6.411a.42.42 0 0 0-.43-.411h-2.144a.42.42 0 0 0-.43.411zM8.257 6.823l-3.003.822V6.411A.42.42 0 0 1 5.683 6h2.145a.42.42 0 0 1 .43.411z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#130E3A",
    d: "M21.29 8.706a1.66 1.66 0 0 0-1.27-1.358 34.2 34.2 0 0 0-7.902-.934c-3.504 0-6.402.57-7.903.934-.672.164-1.17.7-1.27 1.358-.248 1.666-.695 4.861-.695 6.344 0 2.045 1.729 3.702 3.861 3.702 1.837 0 3.372-1.231 3.763-2.88h4.488c.39 1.649 1.925 2.88 3.762 2.88 2.133 0 3.861-1.657 3.861-3.702 0-1.483-.446-4.679-.695-6.344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#46C3F0",
    d: "M19.41 12.579c.475 0 .859-.369.859-.823s-.384-.822-.858-.822-.858.368-.858.822.384.823.858.823"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC22F",
    d: "M15.98 12.579c.473 0 .857-.369.857-.823s-.384-.822-.858-.822-.858.368-.858.822.384.823.858.823"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F71278",
    d: "M17.696 10.934c.474 0 .858-.368.858-.822 0-.455-.384-.823-.858-.823s-.858.368-.858.823.384.822.858.822"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1AD674",
    d: "M17.696 14.227c.474 0 .858-.368.858-.822 0-.455-.384-.823-.858-.823s-.858.368-.858.822c0 .455.384.823.858.823"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.114 10.934h-.858v-.822c0-.455-.384-.823-.858-.823h-.43c-.473 0-.857.368-.857.823v.822h-.858c-.474 0-.858.368-.858.823v.41c0 .455.384.823.858.823h.858v.823c0 .454.384.822.858.822h.429c.474 0 .858-.368.858-.822v-.823h.858c.474 0 .858-.368.858-.822v-.411c0-.455-.384-.823-.858-.823",
    opacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.114 11.141H8.042v-1.028a.63.63 0 0 0-.644-.617H6.97a.63.63 0 0 0-.643.617v1.028H5.253a.63.63 0 0 0-.644.617v.411c0 .34.289.617.644.617h1.073v1.028c0 .34.288.617.643.617h.43a.63.63 0 0 0 .643-.617v-1.028h1.072a.63.63 0 0 0 .644-.617v-.411a.63.63 0 0 0-.644-.617",
    opacity: 0.07
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.97 9.7h.43a.42.42 0 0 1 .428.41v3.702a.42.42 0 0 1-.429.411H6.97a.42.42 0 0 1-.429-.411V10.11a.42.42 0 0 1 .429-.412"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.544 11.759v.411a.42.42 0 0 1-.43.411h-3.86a.42.42 0 0 1-.43-.41v-.412a.42.42 0 0 1 .43-.411h3.86a.42.42 0 0 1 .43.41"
  })));
};
export { SvgMultiColorGamepad as ReactComponent };